import { render } from "./UserForm.vue?vue&type=template&id=1bcc3414&scoped=true&ts=true"
import script from "./UserForm.vue?vue&type=script&lang=ts"
export * from "./UserForm.vue?vue&type=script&lang=ts"

import "./UserForm.vue?vue&type=style&index=0&id=1bcc3414&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bcc3414"]])

export default __exports__